import { useCurrentOverlay } from "shared/context/overlay/OverlayIDContext"
import { useLoginWithIDP } from "shared/lib/useLoginWithIDP"

import { LoginOverlayModel } from "../LoginOverlay"

export function useLoginOverlayModel(): LoginOverlayModel {
  const { closeOverlay } = useCurrentOverlay()
  const { loginAsEmployee, loginAsVisitor } = useLoginWithIDP()

  return {
    loginAsEmployee,
    loginAsVisitor,
    onClose: closeOverlay
  }
}
